import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function MidCTA() {
  return <section className="py-10 md:py-16 bg-brand-900/20 border-y border-brand-500/20 relative overflow-hidden" data-id="element-45">
      <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/fc7QiYSp4FUQA67ttzkACB/Diseno_Sin_Titulo_-_1_-_Editado.png')] bg-cover bg-center opacity-5 mix-blend-overlay" data-id="element-46" />

      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-md mx-auto" data-id="element-48">
          <Button href="https://checkout.promptwearr.shop/cart/44479124242567:1" pulse className="w-full" data-id="element-49">
            👉 Acceder a Prompt Wear ahora
          </Button>
        </motion.div>
      </div>
    </section>;
}